/* eslint-disable import/prefer-default-export */
import { IconColors, Info } from 'Icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

import styles from '../forms.module.css';

interface LabelProps {
    label: string;
    id: string;
    required?: boolean;
    margin?: string;
    hideLabel?: boolean;
    tooltip?: string;
}

export const Label: React.FC<LabelProps> = ({
    id,
    label,
    required = false,
    margin = '0 0 0.5rem',
    hideLabel = false,
    tooltip,
}) => {
    const { t } = useTranslation(['common']);

    return (
        <div className={styles.LabelContainer}>
            <label
                className={styles.Label}
                htmlFor={id}
                style={{
                    display: hideLabel ? 'none' : 'block',
                    margin,
                }}
                data-qa={`label-${label}-${id}`}
            >
                {`${label}${required ? ` (${t('common:required')})` : ''}`}
            </label>
            {tooltip && (
                <>
                    <span data-tooltip-id={`label-tooltip-${id}`} data-tooltip-content={tooltip} className={styles.TooltipIcon}>
                        <Info aspect="1rem" color={IconColors.DarkGrey} />
                    </span>
                    <Tooltip id={`label-tooltip-${id}`} style={{ maxWidth: 220, zIndex: 1 }} />
                </>
            )}
        </div>
    );
};
